import { render, staticRenderFns } from "./NewsAndUpdates.vue?vue&type=template&id=baf042e0&scoped=true&"
import script from "./NewsAndUpdates.vue?vue&type=script&lang=js&"
export * from "./NewsAndUpdates.vue?vue&type=script&lang=js&"
import style0 from "./NewsAndUpdates.vue?vue&type=style&index=0&id=baf042e0&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baf042e0",
  null
  
)

export default component.exports